import { styled } from '@styles/stitches';

export const Square = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$secondaryBackground',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',

  '&:after': {
    content: '',
    display: 'block',
    paddingTop: 'calc(1 * 100%);',
  },
});

export const Draft = styled('div', {
  position: 'absolute',
  top: 8,
  left: 8,
  zIndex: 1,
});

export const TokenHolder = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,

  '& > *': {
    position: 'absolute',
    width: '50%',
    height: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',

    '&:nth-child(4n + 1)': {
      top: '0%',
      left: '0%',
    },

    '&:nth-child(4n + 2)': {
      top: '0%',
      left: '50%',
    },

    '&:nth-child(4n + 3)': {
      top: '50%',
      left: '0%',
    },
    '&:nth-child(4n + 4)': {
      top: '50%',
      left: '50%',
    },
  },
});
